import React from "react";
import { motion } from "framer-motion";
import {
  ArrowLeft,
  LayoutDashboard,
  Filter,
  Zap,
  FileText,
  Upload,
  PenTool,
} from "lucide-react";
import { Link } from "react-router-dom";
import StarBorder from "../../components/signO/ui/StarBorder";

const DashboardFeaturesPage = () => {
  return (
    <div className="min-h-screen bg-dark text-white p-8 pt-24">
      <Link
        to="/"
        className="fixed top-8 left-8 text-gray-400 hover:text-white transition-colors z-50"
      >
        <ArrowLeft className="w-6 h-6" />
      </Link>

      <div className="max-w-4xl mx-auto space-y-16">
        {/* Hero Section */}
        <section className="text-center space-y-6">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-red-600"
          >
            Your Command Center for Digital Contracts
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-xl text-gray-400 max-w-2xl mx-auto"
          >
            Gain total visibility and control over your document lifecycle with
            real-time status updates and quick access to every action required.
          </motion.p>
        </section>

        {/* Filters */}
        <section className="space-y-8">
          <div className="flex items-center gap-3 justify-center mb-8">
            <Filter className="w-8 h-8 text-orange-400" />
            <h2 className="text-3xl font-bold">
              Quick Filters for Instant Clarity
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white/5 p-6 rounded-xl border border-white/10">
              <h3 className="text-xl font-bold text-orange-300 mb-2">
                Actions Required (Pending)
              </h3>
              <p className="text-gray-400">
                Documents waiting specifically for your signature or review.
              </p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-white/10">
              <h3 className="text-xl font-bold text-blue-300 mb-2">
                Sent by Admin
              </h3>
              <p className="text-gray-400">
                Documents you have dispatched; monitor who has viewed it and
                whose signature is outstanding.
              </p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-white/10">
              <h3 className="text-xl font-bold text-green-300 mb-2">
                Signed Documents (Completed)
              </h3>
              <p className="text-gray-400">
                The secure archive of all finalized, Blockchain-linked
                agreements.
              </p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-white/10">
              <h3 className="text-xl font-bold text-purple-300 mb-2">
                Received from Others
              </h3>
              <p className="text-gray-400">
                Documents sent to you for signing by external contacts.
              </p>
            </div>
          </div>
        </section>

        {/* Quick Actions */}
        <section className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 border border-white/10">
          <div className="flex items-center gap-3 mb-8">
            <Zap className="w-8 h-8 text-yellow-400" />
            <h2 className="text-3xl font-bold">Quick Actions Sidebar</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="flex flex-col items-center p-6 bg-white/5 rounded-xl hover:bg-white/10 transition-colors cursor-pointer">
              <FileText className="w-8 h-8 text-white mb-3" />
              <span className="font-medium">Sign New Document</span>
            </div>
            <div className="flex flex-col items-center p-6 bg-white/5 rounded-xl hover:bg-white/10 transition-colors cursor-pointer">
              <Upload className="w-8 h-8 text-white mb-3" />
              <span className="font-medium">Upload File</span>
            </div>
            <div className="flex flex-col items-center p-6 bg-white/5 rounded-xl hover:bg-white/10 transition-colors cursor-pointer">
              <PenTool className="w-8 h-8 text-white mb-3" />
              <span className="font-medium">Manage Signature</span>
            </div>
          </div>
        </section>

        {/* CTA */}
        <div className="text-center pt-8">
          <Link to="/dashboard">
            <StarBorder
              as="button"
              color="cyan"
              speed="4s"
              className="text-lg px-8 py-4"
            >
              Go to Dashboard
            </StarBorder>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardFeaturesPage;
